import { useMemo } from 'react'
import { useLocation, useNavigate } from 'react-router'
import { parseSearchParams } from './parseSearchParams'

export function usePageParams<PageParameters = Record<string, string | undefined>>() {
    const navigate = useNavigate()
    const location = useLocation()

    const pageParams = useMemo(() => parseSearchParams(location.search), [location.search])

    const setPageParams = (newParams: PageParameters | undefined) => {
        if (!newParams) {
            void navigate(location.pathname, { replace: true })
            return
        }
        const currentParams = new URLSearchParams(location.search)
        for (const key in newParams) {
            const value = newParams[key]?.toString()
            if (!value) {
                currentParams.delete(key)
            } else {
                currentParams.delete(key) // Delete and set to maintain same order as in newParams
                currentParams.set(key, value)
            }
        }
        const search = currentParams.toString()
        if (!search) {
            return navigate(location.pathname, { replace: true })
        }
        return navigate(location.pathname + '?' + search, { replace: true })
    }

    return [pageParams, setPageParams] as [PageParameters, typeof setPageParams]
}
